module.exports = __webpack_public_path__ + "prod/1.2.3/img/gift.35cb916e.png";